import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { APIHelperService } from './api-helper.service';
import {
  AccountModel,
  AuthResponseModel,
  TokenModel,
  UserModel,
} from '../../pages/login/account.model';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { map, debounceTime } from 'rxjs/operators';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  httpHeaders: any;
  //private authResponseSubject: BehaviorSubject<AuthResponseModel>;
  //authResponse: Observable<AuthResponseModel>;
  state: any;

  constructor(
    private apiHelperService: APIHelperService,
    private router: Router,
    private loadingController: LoadingController
  ) {
    this.state = this.router.routerState.snapshot;

    this.httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    //this.authResponseSubject = new BehaviorSubject<AuthResponseModel>(JSON.parse(localStorage.getItem('AuthResponse')));
    //this.authResponse = this.authResponseSubject.asObservable();
  }

  public getAuthResponse(): AuthResponseModel {
    let authResponse = new AuthResponseModel();
    try {
      const raw = localStorage.getItem('AuthResponse');
      if (!raw || raw === 'null') {
        return authResponse;
      }
      const response = JSON.parse(raw);
      if (response) {
        authResponse = {
          token: <TokenModel>response.token,
          user: <UserModel>response.user,
        };
      }
    } catch {
      /* ignore corrupt storage */
    }
    return authResponse;
  }

  public authorize(AccountModel: AccountModel): Observable<AuthResponseModel> {
    return new Observable((observer) => {

      this.apiHelperService
        .post(`${environment.apiURI}/auth/login`, AccountModel, this.httpHeaders)
        .subscribe(
          (authResponse) => {
            localStorage.setItem('AuthResponse', JSON.stringify(authResponse));
            observer.next(authResponse);
            observer.complete();
            
          },
          (error) => {
            
          }
        );
    });
  }

  /** Plain bearer string stored by the API (root `token` or nested on token object). */
  public getAccessToken(): string | null {
    try {
      const raw = localStorage.getItem('AuthResponse');
      if (!raw || raw === 'null') {
        return null;
      }
      const response = JSON.parse(raw);
      const t = response?.token;
      if (t == null || t === '') {
        return null;
      }
      if (typeof t === 'string') {
        return t.length > 0 ? t : null;
      }
      if (typeof t === 'object') {
        const bearer =
          (t as any).auth_token || (t as any).access_token || (t as any).token;
        return typeof bearer === 'string' && bearer.length > 0 ? bearer : null;
      }
      return null;
    } catch {
      return null;
    }
  }

  public isUserLoggedIn(): boolean {
    return this.getAccessToken() != null && this.getLoggedInUser() != null;
  }

  public logout(): void {
    localStorage.removeItem('AuthResponse');
    localStorage.removeItem('isActive');
    localStorage.removeItem('profile_image');
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  public saveAuthResponse(authResponse): void {
    localStorage.setItem('AuthResponse', JSON.stringify(authResponse));
  }

  public getLoggedInUser() {
    try {
      const raw = localStorage.getItem('AuthResponse');
      if (!raw || raw === 'null') {
        return null;
      }
      const response = JSON.parse(raw);
      return response?.user ?? null;
    } catch {
      return null;
    }
  }

  public loadUsers(text: string, isLoading: Boolean = true): Observable<any> {
    return new Observable((observer) => {
      let uri = `${environment.apiURI}/common/load-users`;
      this.apiHelperService
        .get(uri, this.httpHeaders, isLoading)
        .pipe(
          //debounceTime(500),  // WAIT for KEY STROKE.
          map((response: any) => {
            let result = [];
            response.forEach(function (object) {
              result.push({ name: object.name, id: object.id });
            });

            observer.next(result);
            observer.complete();
          })
        )
        .subscribe();
    });
  }

  public changePassword(changePasswordModel): Observable<any> {
    return new Observable((observer) => {
      let uri = `${environment.apiURI}/change-password`;
      this.apiHelperService
        .post(uri, changePasswordModel, this.httpHeaders)
        .pipe(
          //debounceTime(500),  // WAIT for KEY STROKE.
          map((response: any) => {
            observer.next(response);
            observer.complete();
          })
        )
        .subscribe();
    });
  }

  public confirmSchoolCode(code: string): Observable<any> {
    return new Observable((observer) => {
      let uri = `${environment.apiURI}/validate-school-code`;

      this.httpHeaders = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'schoolCode': code,
        }),
      };

      this.apiHelperService
        .post(uri, { code: code }, this.httpHeaders)
        .pipe(
          map((response: any) => {
            observer.next(response);
            observer.complete();
          })
        )
        .subscribe();
    });
  }

  public savePushToken(token: string): Observable<any> {

    return new Observable((observer) => {
      let uri = `${environment.apiURI}/save-push-token`;
      let userId = this.getLoggedInUser().id;
      this.apiHelperService
        .post(uri, { token: token, user_id: userId }, this.httpHeaders)
        .pipe(
          map((response: any) => {
            observer.next(response);
            observer.complete();
          })
        )
        .subscribe();
    });
  }

  hasPermission(permission: any) {

    let currentUserValue = this.getLoggedInUser();
    
    if (currentUserValue) {
     
      if(currentUserValue.is_admin) {
        return true;
      }

      if ((currentUserValue.roles && currentUserValue.roles.length > 0)) {
        let userPermissions = currentUserValue.roles.map((role: any) => role.name).flat();
        
        if(permission.allowed_roles?.some((role: string) => userPermissions.includes(role))) {
          return true;
        }
      }
      
      if (currentUserValue.module_permissions && currentUserValue.module_permissions.length > 0) {
        
        return permission.permissions?.some((perm: string) => currentUserValue.module_permissions.includes(perm));
      }
    }
    return false;
  }
}
